import { ChangeDetectorRef, Directive, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { BreakpointService } from '../breakpoint/breakpoint.service';
import { BreakpointKey } from '../helpers/css-utils';

@Directive({
  selector: '[shrdUtcWarningIndicator]'
})
export class WarningIndicatorDirective implements OnInit, OnDestroy {
  @Input() shrdUtcWarningIndicator: boolean;
  @Input() shrdUtcWarningIndicatorImageVariant: boolean;
  @Input() shrdUtcWarningIndicatorBreakpointMax: BreakpointKey;

  @HostBinding('class.icon-warning-indicator')
  get isVisible() {
    return this.shrdUtcWarningIndicator && this.warningIndicatorVisible;
  }

  @HostBinding('class.icon-warning-indicator-image-variant')
  get isImageVariant() {
    return this.shrdUtcWarningIndicator && this.shrdUtcWarningIndicatorImageVariant;
  }

  constructor(private readonly breakpointService: BreakpointService, private readonly cdr: ChangeDetectorRef) {}

  private warningIndicatorVisible = false;
  private readonly ngUnsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.isWarningIndicatorVisibleCheck();
    this.breakpointService.breakpointChange$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => this.isWarningIndicatorVisibleCheck());
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private isWarningIndicatorVisibleCheck() {
    this.warningIndicatorVisible = this.breakpointService.isWithinMaxBound(this.shrdUtcWarningIndicatorBreakpointMax);
    this.cdr.detectChanges();
  }
}
